import { PacketIn } from "./PacketIn.js";
import { InboundPacketType } from "./InboundPacketType.js";
import { readJsonDict, readNullableJsonChar } from "../../../../util/json.js";
import type { MessageIOContext } from "../../../api/MessageIOContext.js";
import { PlayerType } from "../../../../royalur/model/PlayerType.js";
import type { LobbyPlayer } from "../../../lobby/LobbyPlayer.js";


export class PacketInPlayerData extends PacketIn {
    public yourPlayer: PlayerType | null = null;
    public player1: LobbyPlayer | null = null;
    public player2: LobbyPlayer | null = null;

    constructor() {
        super(InboundPacketType.PLAYER_DATA);
    }

    getPlayer(playerType: PlayerType): LobbyPlayer {
        if (this.player1 === null || this.player2 === null)
            throw new Error("Packet has not been read");

        const data1 = this.player1.getGameData();
        return data1?.getPlayerType() === playerType ? this.player1 : this.player2;
    }

    override readContents(
        context: MessageIOContext,
        json: Record<string, any>,
    ): void {
        const yourPlayerChar = readNullableJsonChar(json, "your_player");
        this.yourPlayer = (yourPlayerChar !== null ? PlayerType.getByChar(yourPlayerChar) : null);

        const lobbyNotation = context.getLobbyNotation();
        this.player1 = lobbyNotation.readLobbyPlayer(readJsonDict(json, "player1"));
        this.player2 = lobbyNotation.readLobbyPlayer(readJsonDict(json, "player2"));
    }
}
